import { useCustomerAuthStore } from '../stores/auth'
import { Button } from '@/components/ui'

export function ImpersonationBanner() {
  const isImpersonation = useCustomerAuthStore((s) => s.isImpersonation)
  const logout = useCustomerAuthStore((s) => s.logout)

  if (!isImpersonation) return null

  return (
    <div className="bg-red-600 text-white py-2 px-4 text-small flex items-center justify-between">
      <div>
        <strong>Impersonation aktiv:</strong> Du handelst gerade im Namen eines Kunden. Alle Aktionen werden im Audit-Log festgehalten.
      </div>
      <Button
        variant="secondary"
        size="xs"
        onClick={() => { logout(); window.close() }}
      >
        Session beenden
      </Button>
    </div>
  )
}
